<template>
<div>

    <h1> Page not found</h1>
</div>
</template>
<script>

  import commonServices from "@/shared/commonServices"

export default {
    mixins: [commonServices],

    mounted(){
        this.goMain();
        //this.$el.querySelector('#LoginUserName').focus = true;
    },
    name:"Page not found",
    methods:{
        goMain: function(){
            this.$router.push({ name: 'login'});
        },
    },
};
</script>
<style scoped>
@import "css/main.css"
</style>
